import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/img/protractor_logo_rev.svg'


const _hoisted_1 = { class: "banner" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Manager Client", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "signature" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Powered by"),
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0,
    alt: "Protractor"
  })
], -1)

import { useAuth0 } from '@auth0/auth0-vue';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Signature',
  setup(__props) {

const auth0 = useAuth0();
const isAuthenticated = ref(auth0.isAuthenticated);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (isAuthenticated.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _hoisted_5))
        : _createCommentVNode("", true)
    ]),
    _hoisted_6
  ]))
}
}

})